 
import { Entity } from './entity';
import { Region } from './region';

export class PostalCode extends Entity {
    public id: number;
    public code: string;
    public region: Region;

  }  